import { type Draft, immerable } from "immer";
import type { Site } from "@/shared/model/user/UserDomains.ts";

export class ScheduleReferenceDataState {
  [immerable] = true;
  constructor(
    public readonly site: Site | undefined = undefined,
    public readonly referenceDataAreStale = false,
    public readonly siteScheduleTemplatesAreStale = false,
    public readonly loadingError = false,
  ) {}

  public isStale(): boolean {
    return this.referenceDataAreStale || this.siteScheduleTemplatesAreStale;
  }
}

export type ScheduleReferenceDataStateAction =
  | { type: "referenceDataChangeSite"; site: Site }
  | { type: "referenceDataMarkStale" }
  | { type: "referenceDataSettled"; errorOccurred: boolean }
  | { type: "siteScheduleTemplatesMarkStale" }
  | {
      type: "siteScheduleTemplatesSettled";
      errorOccurred: boolean;
    };

export function reducer(
  draft: Draft<ScheduleReferenceDataState>,
  action: ScheduleReferenceDataStateAction,
): void {
  switch (action.type) {
    case "referenceDataChangeSite": {
      draft.site = action.site;
      draft.referenceDataAreStale = true;
      draft.siteScheduleTemplatesAreStale = false;
      draft.loadingError = false;
      break;
    }
    case "referenceDataMarkStale": {
      draft.referenceDataAreStale = true;
      break;
    }
    case "referenceDataSettled": {
      draft.referenceDataAreStale = false;
      draft.siteScheduleTemplatesAreStale = false;
      draft.loadingError = action.errorOccurred;
      break;
    }
    case "siteScheduleTemplatesMarkStale": {
      draft.siteScheduleTemplatesAreStale = true;
      draft.loadingError = false;
      break;
    }
    case "siteScheduleTemplatesSettled": {
      draft.siteScheduleTemplatesAreStale = false;
      draft.loadingError = action.errorOccurred;
      break;
    }
  }
}
